import React, {FC} from 'react';
import {Navigate} from 'react-router-native';

// Path.SUPPORT, inlined on purpose. This component is referenced by routes.definition (via
// routes.components), so importing Path back from routes.definition here closes a load-order-sensitive
// dependency cycle that can resolve to `undefined`. The literal is kept honest by the tests
// (SupportFaqsRedirect.test / faqsAuthRedirect.test), which route to the real Path.SUPPORT and fail
// on any drift.
const SUPPORT_PATH = '/support';

/**
 * Registered at `/faqs` for authenticated users only — the public /faqs route serves the anonymous
 * chat, while logged-in visitors are sent to the authenticated /support entry instead.
 */
const SupportFaqsRedirect: FC = () => <Navigate to={SUPPORT_PATH} replace />;

export {SupportFaqsRedirect};
